// extracted by mini-css-extract-plugin
module.exports = {"container":"loader_with_text-module__container--3BRps","text":"loader_with_text-module__text--2usNa"};